import Controller from "./loan.controller";
import template from "./loan.html";

const loan = {
  template,
  controller: Controller,
};

export default loan;



// WEBPACK FOOTER //
// ./src/pages/loan/loan.component.js